import React from 'react'
import cx from 'classnames'
import { Icon } from '@softwaredev_cegeka/stix-core/'
// Styles
import styles from './loader.module.scss'

export default function Loader({
    inline,
    className,
    children,
    animate = true,
    ...rest
}) {
    return (
        <div
            role={'status'}
            className={cx(styles.loadingOverlay, className)}
            {...rest}
        >
            <div className="d-flex">
                <Icon
                    className={cx(styles.loaderIcon, {
                        [styles.loaderInline]: inline,
                        [styles.animate]: animate,
                    })}
                    icon={'loading'}
                    spin
                />
            </div>
            {children}
        </div>
    )
}
